<template>
  <div class="newIndex">
    <div class="menu_list">
      <div class="menu_Info">
        <img src="/newIndex/1.png">
        <div class="menu_right">
          <div class="text">全天候品质服务</div>
          <div class="title">7x24小时专业工程师服务</div>
        </div>
      </div>
      <div class="menu_Info">
        <img src="/newIndex/2.png">
        <div class="menu_right">
          <div class="text">极速服务应答</div>
          <div class="title">快速应答为业务保驾护航</div>
        </div>
      </div>
      <div class="menu_Info">
        <img src="/newIndex/3.png">
        <div class="menu_right">
          <div class="text">客户价值为先</div>
          <div class="title">从服务价值到创造客户价值</div>
        </div>
      </div>
      <div class="menu_Info">
        <img src="/newIndex/4.png">
        <div class="menu_right">
          <div class="text">全方位安全保障</div>
          <div class="title">打造一款透明可信的软件</div>
        </div>
      </div>
    </div>
    <div class="card_list">
      <div class="card_info">
        <div class="card_top">
          <div class="card_text">专精特新企业</div>
          <div class="card_title">深耕智慧医疗的创新引领者</div>
        </div>
        <div class="card_bottom">
          <div class="card_bottom_box">
            <div class="card_bottom_text">专业化能力</div>
            <div class="card_bottom_title">聚焦医疗科技细分市场的核心需求</div>
            <div class="card_bottom_list">
              <div class="card_bottom_list_info">专注智慧医疗技术研发与产业化</div>
            </div>
          </div>
          <div class="card_bottom_box">
            <div class="card_bottom_text">特色化优势</div>
            <div class="card_bottom_title">构建差异化医疗解决方案</div>
            <div class="card_bottom_list">
              <div class="card_bottom_list_info">融合人工智能与生物医学工程的特色技术体系</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card_info2">
        <div class="card_top">
          <div class="card_text">高新技术企业</div>
          <div class="card_title">技术驱动发展的创新智能平台</div>
        </div>
        <div class="card_bottom">
          <div class="card_bottom_box">
            <div class="card_bottom_text">自主研发能力</div>
            <div class="card_bottom_title">掌握核心知识产权与专利技术</div>
            <div class="card_bottom_list">
              <div class="card_bottom_list_info">累计申请发明专利、实用新型、外观专利和软著多项</div>
            </div>
          </div>
          <div class="card_bottom_box">
            <div class="card_bottom_text">持续创新体系</div>
            <div class="card_bottom_title">产学研协同的研发机制</div>
            <div class="card_bottom_list">
              <div class="card_bottom_list_info">研发投入占比超10%，合作客户近千家</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card_info3">
        <div class="card_top">
          <div class="card_text">科技型中小企业</div>
          <div class="card_title">创新活力强劲的科技成长型企业</div>
        </div>
        <div class="card_bottom">
          <div class="card_bottom_box">
            <div class="card_bottom_text">技术创新布局</div>
            <div class="card_bottom_title">聚焦高成长性医疗科技领域</div>
            <div class="card_bottom_list">
              <div class="card_bottom_list_info">覆盖智能导诊、智能影像诊断、智能预诊等前沿方向</div>
            </div>
          </div>
          <div class="card_bottom_box">
            <div class="card_bottom_text">成果转化能力</div>
            <div class="card_bottom_title">快速响应临床需求的敏捷开发模式</div>
            <div class="card_bottom_list">
              <div class="card_bottom_list_info">年均推出创新产品/服务多项，市场覆盖率持续提升</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="middle_box_list">
      <div class="text_list">
        <div class="text_text">产品中心</div>
        <div class="text_title">
          <i></i>
          产品器材设备  产品设备厂家
          <i></i>
        </div>
      </div>
      <div class="top_list" >
        <div :class="tarIndex === index ?'tar_info blue':'tar_info'" v-for="(item,index) in tarList" :key="index" @mouseover="select(index)" @click="select(index)">
          <div class="item">{{item}}</div>
        </div>
        <div :class="gengduoIndex === 1 ? 'gengduo blue':'gengduo'" @click="goToGengDuo" @mouseleave ="mouseleaveIndex"  @mouseover="selectGengDuoIndex(1)">更多</div>
      </div>
      <div class="core_list">
        <div class="core_info" v-for="(item,index) in coreProductList[tarIndex]" :key="index" @click="toCheck(item)">
          <div class="image">
            <el-image class="list_left-img" :src="item.img" fit = 'contain' />
            <el-image class="imgInfo" v-if="item.imgInfo" :src="item.imgInfo" fit = 'contain' />
          </div>
          <div class="name">{{item.name}}</div>
          <div class="info" v-html="removeImagesFromHTML(item.info)"></div>
        </div>
      </div>
    </div>


    <div class="lightModuleOuterContent">
      <div class="lightModuleOuterContent_text">
        丰富多样的营销应用助您玩转营销
      </div>
      <div class="lightModuleOuterContent_title">
        丰富多样的营销应用助您玩转营销
      </div>
      <div class="formTabButtonList">
        <div :class="toTextIndex === index ?'formTabButtonInfo blue':'formTabButtonInfo'" v-for="(item,index) in textList" :key="index" @mouseover="toText(index)" @click="toText(index)">
          {{item}}
        </div>
      </div>
      <div class="textListInfo_list" >
        <div class="text_list_left">
          <div class="text_list_text"> {{textListInfo[toTextIndex].text}}</div>
          <div class="text_list_title"> {{textListInfo[toTextIndex].title}}</div>
        </div>
        <div class="image_right">
          <el-image
              class="imgInfo" :src="textListInfo[toTextIndex].img"
              :preview-src-list="[textListInfo[toTextIndex].img]">
          </el-image>
        </div>
      </div>
    </div>

    <div class="fullMeasureOuterContent">
      <div class="fullMeasureOuterContent_list">
        <div class="fullMeasureOuterContent_left">
          <div class="fullMeasureOuterContent_text">“互联网+医疗” 实践者</div>
          <div class="fullMeasureOuterContent_info">
            利用先进的信息技术手段实现医疗资源共享，医疗数据互通，提高医疗服务治疗与效率，公司始终致力于医疗健康领域的创新和发展，在国家“互联网+医疗健康”制度的指引下,持续推动技术创新和产品升级，秉承“用科技服务人类健康”的理念，推动世界医疗健康事业发展，成为大健康行业的佼佼者。</div>
          <div class="fullMeasureOuterContent_sbtn" @click="goToBusinessCooperation">
            立即咨询
          </div>
        </div>
        <div class="fullMeasureOuterContent_right">
          <div class="hezi">
            <div class="sz">100</div>
            <div class="zy">专业</div>
          </div>
          <div class="hezi">
            <div class="sz">100</div>
            <div class="zy">技术</div>
          </div>
          <div class="hezi">
            <div class="sz">100</div>
            <div class="zy">服务</div>
          </div>
        </div>
      </div>
    </div>

    <div class="about_product">
      <div class="about_product_info">
        <h2 class="ap_title">湖南岳泰兴医疗科技有限公司 · 智慧医疗整体解决方案提供商</h2>
        <div class="ap_p">
          湖南岳泰兴医疗科技有限公司是一家致力于大健康领域的高新技术企业，秉承“用科技服务人类健康”的理念，围绕医疗机构信息化系统建设与康复理疗设备研发生产销售，提供智慧医院、互联网医院、智慧病房、智慧门诊、智慧养老等整体解决方案。
        </div>
        <div class="ap_p">
          智慧导诊是新一代人工智能产品方向。岳泰兴智慧导诊系统以智慧导诊一体机（挂号缴费一体机、医院自助服务终端）为核心终端，融合人工智能与物联网技术，面向医院门诊场景提供智能分诊、科室信息查询、院内导航与健康宣教，并保留传统医院自助机中的挂号缴费、报告查询打印等功能，帮助医院优化就医流程、缓解窗口排队压力。作为湖南的智慧导诊一体机与医院自助机厂家，岳泰兴医疗可根据医院实际场地条件与业务流程提供适配方案。
        </div>
        <div class="ap_p">
          除智慧导诊产品线外，公司产品还涵盖智慧病房、智慧门诊、互联网医院、HIS系统、住院床旁交互、智慧心理、智慧中医等医疗信息化产品，并覆盖康复理疗设备，形成“信息化系统 + 医疗设备”双线并行的产品体系。
        </div>
      </div>
    </div>

    <div class="news_list">
      <div class="new_top">
        <span style="font-size: 24px; color: rgb(153, 153, 153);">NEWS</span>
        <div style="font-size: 40px; color: rgb(51, 51, 51);">新闻动态</div>
      </div>
      <div class="new_bottom">
        <div class="new_bottom_left">
          <img src="/newIndex/13.jpg">
        </div>
        <div class="new_bottom_right">
          <div class="left_info"  @click="toCheckEnt(item)" v-for="(item,index) in enterpriseList.slice(0,3)" :key="index">
            <div class="image">
              <img :src="item.img">
            </div>
            <div class="info">

              <div class="info_text">
                {{item.text}}
              </div>
              <div class="info_title" v-html="removeImagesFromHTML(item.info)"></div>
              <div class="time">
                {{item.time}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="fullmeasureContentBg">
      <div class="biaoti">专业智慧医疗信息化解决方案，请联系我们！</div>
      <div class="neirong">快速响应 | 精准服务 | 全流程赋能</div>
      <div class="sub" @click="goToBusinessCooperation">立即联系</div>
    </div>

    <div class="partner">
      <div class="text_list">
        <div class="text_text">合作客户</div>
        <div class="text_title">
          <i></i>
          部分合作客户
          <i></i>
        </div>
      </div>
      <div class="partner_list">
        <div class="partner_list_info">
          <img src="/newIndex/101.png">
          <div class="wenzi">湖南省第二人民医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/102.png">
          <div class="wenzi">长沙市第四医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/103.png">
          <div class="wenzi">湖南省妇幼保健院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/104.png">
          <div class="wenzi">湖南中医药大学第二附属医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/105.png">
          <div class="wenzi">长沙市第三医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/106.png">
          <div class="wenzi">湖南航天医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/107.png">
          <div class="wenzi">长沙市妇幼保健院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/108.png">
          <div class="wenzi">长沙市口腔医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/109.png">
          <div class="wenzi">湖南省中西医结合医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/110.png">
          <div class="wenzi">湖南省胸科医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/111.png">
          <div class="wenzi">中南大学湘雅三医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/113.png">
          <div class="wenzi">中南大学湘雅医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/113.jpg">
          <div class="wenzi">湖南联通</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/114.jpg">
          <div class="wenzi">湖南移动</div>
        </div>
<!--        <div class="partner_list_info">-->
<!--          <img src="/newIndex/115.jpg">-->
<!--          <div class="wenzi">湘雅三医院</div>-->
<!--        </div>-->
        <div class="partner_list_info">
          <img src="/newIndex/116.jpg">
          <div class="wenzi">国防科技大学</div>
        </div>
<!--        <div class="partner_list_info">-->
<!--          <img src="/newIndex/117.jpg">-->
<!--          <div class="wenzi">株洲市监狱</div>-->
<!--        </div>-->
        <div class="partner_list_info">
          <img src="/newIndex/118.jpg">
          <div class="wenzi">长沙市第四人民医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/119.png">
          <div class="wenzi">湖南交通医院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/120.jpg">
          <div class="wenzi">雨花疾控中心</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/121.png">
          <div class="wenzi">长沙航空职业技术学院</div>
        </div>
        <div class="partner_list_info">
          <img src="/newIndex/123.png">
          <div class="wenzi">长沙民政职业技术学院</div>
        </div>
      </div>
    </div>

    <tail_menu></tail_menu>
  </div>
</template>

<script>
import {coreProductList, enterpriseList} from '@/views/mock'
import tail_menu from "@/components/tail_menu";
export default {
  name: "newIndex",
  components:{
    tail_menu
  },
  data(){
    return{
      gengduoIndex:0,
      enterpriseList:enterpriseList,
      textListInfo:[
        {
          text:'面向医院智慧化的全面解决方案',
          title:'岳泰兴智慧医院是面向医院智慧化的全面解决方案，智慧医院以实现自动化医疗为核心，通过信息化技术、智能化设备、AI和大数据分析等现代科技手段，将传统医疗服务升级为全方位，全过程数字化、智能化和协同化的高端医疗模式。不仅可以提高医生诊疗效率和准确度，还能实现个性化医疗服务、精准预防与健康管理等，促进医患关系和谐，打造院内精细化管理为导向的医院智慧化管理系统。\n',
          img:'/newIndex/8.jpg',
        },
        {
          text:'以医院为主体的互联网医疗服务平台',
          title:'岳泰兴互联网医院是建立以医院为主体的互联网医疗服务平台，构建“线上预诊-线下面诊与治疗-线上复诊”的新型医疗模式。提供云诊室，方便医生在院外不同环境中利用互联网医院平台进行诊疗服务，充分利用“互联网+”实现多渠道预约、智能导诊、挂号、账单支付、查询、医保支付、评价等基本服务以“数据多跑路，患者少跑路”为核心，实现脱卡就诊，手机医保支付等全新服务。\n',
          img:'/newIndex/9.jpg',
        },
        {
          text:'将医疗、康复、养生和养老结合的新型医养一体化的理念',
          title:'岳泰兴智慧养老平台采用医养一体化的理念，将医疗、康复、养生和养老等为一体化，为用户提供全面的养老服务，打造机构养老与居家养老、生活照料与康复关怀相融合的全新智慧养老服务平台，覆盖全场景养老管理体系。通过岳泰兴智慧养老平台，用户可以方便地获取医疗、康复和养老等各种服务为用户打造一个舒适、安全、有趣的养老环境，以提高生活品质和健康状况。\n',
          img:'/newIndex/10.jpg',
        },
        {
          text:'医院智慧导诊导航一体解决方案',
          title:'岳泰兴智慧导诊导航一体机是为应对传统医疗导诊困境而打造的智慧医疗解决方案。传统导诊方式下，患者就医面临诸多不便，如不知如何挂号、难以找到科室位置等，严重影响就医体验。智慧导诊机功能丰富，能根据患者症状智能匹配挂号科室，提供全面的科室和医生信息查询服务，还具备院内导航与健康宣教功能。它有效提升了就医效率，缓解医院导诊压力，且可根据医院需求定制服务。该产品在优化就医流程、改善医患关系等方面发挥重要作用，有力推动了医院的智慧化建设。',
          img:'/newIndex/11.jpg',
        },
      ],
      coreProductList:coreProductList,
      tarIndex:0,
      toTextIndex:0,
      tarList:[
        '智慧医疗',
        '智慧病房',
        '智慧门诊',
        '互联网医疗'
      ],
      textList:[
        '智慧医院',
        '互联网医院',
        '智慧养老',
        '智慧导诊'
      ]
    }
  },
  methods:{
    goToGengDuo(){
      this.$router.push({name: 'coreProduct',query:{fid:0}})
    },
    selectGengDuoIndex(index){
      this.gengduoIndex= index
    },
    mouseleaveIndex(){
      this.gengduoIndex= 0
    },
    goToBusinessCooperation(){
      this.$router.push({name: 'businessCooperation', query: {slide: 'slide'}})
    },
    toCheckEnt(item) {
      this.$router.push({name: 'enterpriseInformationInfo', query: {id: item.id}})
    },
    removeImagesFromHTML(html) {
      return html.replace(/<(img|div)[^>]*>/gi, '');
    },
    select(index){
      this.tarIndex = index
    },
    toText(index){
      this.toTextIndex = index
    },
    toCheck(item) {
      this.$router.push({name: 'coreProductInfo', query: {id: item.id}})
    }
  }
}
</script>

<style scoped lang="scss">
.menu_list{
  padding: 50px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid rgba(237, 237, 237, 1);
  .menu_Info{
    border-right: 1px solid rgba(237, 237, 237, 1);
    padding: 10px 60px;
    display: flex;
    align-items: center;
    img{
      width: 36px;
      height: 40px;
    }
    .menu_right{
      margin-left: 14px;
      .text{
        font-size: 16px;
      }
      .title{
        font-size: 14px;
        color: rgb(153, 153, 153);;
        margin-top: 10px;
        white-space: nowrap;
      }
    }
  }
  .menu_Info:last-child{
    border: none;
  }
}
.card_list{
  background-image: url("/newIndex/15.jpg");
  background-repeat: no-repeat;
  border-bottom: 1px solid rgba(237, 237, 237, 1);
  padding: 60px 50px 50px 50px;
  display: flex;
  justify-content: center;
  .card_info,.card_info2,.card_info3{
    width: 420px;
    height: 500px;

    .card_top{
      margin-top: 50px;
      margin-left: 64px;
      .card_title{
        margin-top: 10px;
      }
    }
    .card_bottom{
      margin-left: 64px;
      margin-top: 50px;
      .card_bottom_box{
        margin-top: 40px;
        .card_bottom_text{
          font-size: 18px;
        }
        .card_bottom_title{
          color: rgb(102, 102, 102);
          font-size: 14px;
          margin-top: 14px;
        }
        .card_bottom_list{
          display: flex;
          align-items: center;
          margin-top: 14px;
          .card_bottom_list_info{
            padding: 0 14px;
            height: 32px;
            min-width: 260px;
            line-height: 32px;
            border-radius: 3px;
            text-align: center;
            border: 1px solid rgba(221, 226, 233, 1);
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-right: 14px;
          }
        }
      }
    }
  }
  .card_info{
    background: url("/status/111.png");
    background-position: center;
    .card_top{
      .card_text{
        font-size: 24px;
        color: rgb(19, 87, 189);
      }
      .card_title{
        color: rgb(19, 87, 189);
        font-size: 14px;
      }
    }

  }
  .card_info2{
    background: url("/newIndex/6.png");
    background-position: center;
    .card_top{
      .card_text{
        font-size: 24px;
        color: rgb(13, 114, 170)
      }
      .card_title{
        color: rgb(13, 114, 170);
        font-size: 14px;
      }
    }

  }
  .card_info3{
    background: url("/status/111.png");
    background-position: center;
    .card_top{
      .card_text{
        font-size: 24px;
        color: rgb(92, 67, 164);
      }
      .card_title{
        color: rgb(92, 67, 164);
        font-size: 14px;
      }
    }

  }
}


.middle_box_list{
  border-bottom: 1px solid rgba(237, 237, 237, 1);
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 60px;
  .text_list{
    .text_text{
      font-size: 38px;
      font-weight: bold;
      color: #222222;
      text-align: center;
    }
    .text_title{
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 16px;
      text-align: center;
      color: #666666;
      i{
        display: inline-block;
        vertical-align: middle;
        width: 94px;
        height: 1px;
        background: #A6A6A6;
        margin: 0 25px;
      }
    }
  }
  .top_list{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1200px;
    padding: 14px 0;
    margin-left: 80px;
    .gengduo{
      white-space: nowrap;
      cursor: pointer;
      font-size: 18px;
      background-color: #eeeeee;
      border-radius: 20px;
      padding: 10px 80px;
    }
    .tar_info{
      margin-right: 60px;
      padding: 10px 80px;
      justify-content: center;
      cursor: pointer;
      font-size: 18px;
      display: flex;
      background-color: #eeeeee;
      border-radius: 20px;
      .item{
        white-space: nowrap;
      }

    }
    .blue{
      color: white;
      background: #3faaf9;
      font-weight: bold;
    }
  }
  .core_list{
    display: flex;
    flex-wrap: wrap;
    width: 1200px;
    margin-top: 20px;
    .core_info{
      cursor: pointer;
      background: white;
      //box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
      margin-bottom: 30px;
      margin-left: 30px;
      border-radius: 8px;
      .image{
        position: relative;
        .list_left-img{
          width: 260px;
          height: 240px;
        }
        .imgInfo{
          position: absolute;
          left: 35px;
          top: 34px;
          width: 188px;
          height: 108px;
        }
      }
      .name{
        text-align: center;
        margin-top: 10px;
        font-size: 18px;
        padding-bottom: 10px;
        margin-bottom: 10px;
        font-weight: bold;
        border-bottom: 1px #e2e2e2 solid;
      }
      .info{
        color: #777777;
        font-size: 14px;
        width: 260px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}

.lightModuleOuterContent{
  border-bottom: 1px solid rgba(237, 237, 237, 1);
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 60px;
  .lightModuleOuterContent_text{
    font-size: 38px;
    font-weight: bold;
    color: rgb(51, 51, 51);
  }
  .lightModuleOuterContent_title{
    color: rgb(153, 153, 153);
    font-size: 16px;
    margin-top: 10px;
  }
  .formTabButtonList{
    width: 1200px;
    border-bottom: 1px solid rgba(237, 237, 237, 1);
    display: flex;
    justify-content: space-around;

    .formTabButtonInfo{
      font-family: 微软雅黑;
      color: rgba(51, 51, 51, 1);
      font-size: 28px;
      font-weight: bold;
      //font-weight: normal;
      padding: 30px;
      cursor: pointer;

    }
    .blue{
      color: rgba(7, 108, 224, 1);
      border-bottom: 1.5px solid rgba(7, 108, 224, 1);
    }
  }
  .textListInfo_list{
    display: flex;
    justify-content: space-between;
    padding: 90px 0 60px 0;
    width: 1200px;
    .text_list_left{
      margin-top: 50px;
      .text_list_text{
        font-size: 26px;
        color: rgb(51, 51, 51);
        margin-bottom: 50px;
      }
      .text_list_title{
        width: 450px;
        font-size: 16px;
        line-height: 30px;
        display: inline-block;
        color: rgb(153, 153, 153);
      }
    }
    .image_right{
      animation: ceshi 2s forwards;
      .imgInfo{
        width: 550px;
        height: 417px;
      }
    }
  }
}

.fullMeasureOuterContent{
  background-image: url("/newIndex/12.jpg");
  height: 490px;
  width: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  .fullMeasureOuterContent_list{
    width: 1200px;
    display: flex;
    align-items: center;
    .fullMeasureOuterContent_left{
      .fullMeasureOuterContent_text{
        font-size: 24px;
        color: rgb(255, 255, 255);
      }
      .fullMeasureOuterContent_info{
        margin-top: 24px;
        font-size: 14px;
        color: rgb(255, 255, 255);
        line-height: 36px;
        display: inline-block;
        width: 330px;
      }
      .fullMeasureOuterContent_sbtn{
        margin-top: 20px;
        border: 1px solid white;
        width: 140px;
        height: 40px;
        border-radius: 4px;
        line-height: 40px;
        color: white;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
      }
    }
    .fullMeasureOuterContent_right{
      margin-left: 60px;
      display: flex;
      align-items: center;
      width: 63%;
      .hezi{
        border-right: 1px solid rgb(232,232,232);
        padding: 0 92px;
      }
      .hezi:last-child{
        border: none;
      }
      .sz{
        font-size: 36px;
        font-weight: bold;
      }
      .zy{
        font-size: 16px;
        color: rgb(153, 153, 153);
        text-align: center;
      }
    }
  }

}

.news_list{
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 60px;
  .new_top{
    width: 1200px;
    border-bottom: 1px solid rgba(237, 237, 237, 1);
    padding-bottom: 20px;
  }
  .new_bottom{
    width: 1200px;
    padding: 40px 0;
    display: flex;
    .new_bottom_left{
      img{
        width: 400px;
        height:500px;
      }
    }
    .new_bottom_right{
      margin-left: 30px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .left_info{
        display: flex;
        cursor: pointer;
        .image{
          img{
            width: 230px;
            height: 150px;
          }
        }
        .info{
          margin-left: 30px;
        }
        .info_text{
          width: 500px;
          color: #333;
          font-size: 16px;
          margin-top: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .info_title{
          width: 500px;
          color: #666;
          font-size: 14px;
          margin-top: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .time{
          font-size: 14px;
          color: #999;
          margin-top: 20px;
        }
      }
    }
  }
}
.fullmeasureContentBg{
  background-image: url("/newIndex/14.jpg");
  height: 170px;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 60px 0;
  .biaoti{
    font-size: 30px;
  }
  .neirong{
    font-size: 18px;
  }
  .sub{
    background: rgba(7, 108, 224, 1);
    color: white;
    border-radius: 4px;
    font-size: 14px;
    width: 130px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
}

.partner{
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 60px;
  .text_list{
    .text_text{
      font-size: 38px;
      font-weight: bold;
      color: #222222;
      text-align: center;
    }
    .text_title{
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 16px;
      text-align: center;
      color: #666666;
      i{
        display: inline-block;
        vertical-align: middle;
        width: 94px;
        height: 1px;
        background: #A6A6A6;
        margin: 0 25px;
      }
    }
  }
}

.partner_list{
  display: flex;
  //justify-content: center;
  flex-wrap: wrap;
  width: 1300px;
  .partner_list_info{
    width: 23%;
    display: flex;
    align-items: center;
    margin-top: 30px;
    margin-right: 20px;
    .wenzi{
      margin-left: 20px;
      font-size: 18px;
      font-family: '楷体';
      white-space: nowrap;
    }
    img{
      width: 80px;
    }
  }
}

/* 首页产品/公司介绍文字模块：同时承担 SEO 正文内容 */
.about_product{
  display: flex;
  justify-content: center;
  padding: 60px 60px 50px 60px;
  background-color: rgba(247,249,252,1);
  .about_product_info{
    width: 1200px;
    .ap_title{
      margin: 0 0 40px 0;
      font-size: 34px;
      font-weight: bold;
      color: rgb(51,51,51);
      text-align: center;
    }
    .ap_p{
      font-size: 16px;
      line-height: 32px;
      color: rgb(102,102,102);
      margin-bottom: 18px;
      text-indent: 2em;
    }
  }
}
</style>
